import React, { FC } from 'react';

const DeprecatedNote: FC = (): JSX.Element => {
  const NEW_PORTAL_URL: string = (window as any)['platformConfig']?.NEW_PORTAL_URL;
  return (
    <div
      style={{
        backgroundColor: 'white',
        color: 'red',
        display: 'grid',
        placeItems: 'center'
      }}>
      <p>
        This portal is being deprecated and will no longer support triggering new jobs. To initiate
        new jobs, please visit:{' '}
        <a target="blank" href={NEW_PORTAL_URL}>
          EY Blockchain Analyzer
        </a>
      </p>
    </div>
  );
};

export default DeprecatedNote;
